import {
  GET_LAW_MATTERS,
  GET_LAW_MATTER,
  CREATE_LAW_MATTER,
  UPDATE_LAW_MATTER,
  DELETE_LAW_MATTER
} from '../actions/lawMatterActions';

const initialState = {
  matters: [],
  matter: null,
  isLoading: false,
  error: null
};

const lawMattersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LAW_MATTERS:
      return {
        ...state,
        matters: Array.isArray(action.payload) ? action.payload : [],
        isLoading: false
      };

    case GET_LAW_MATTER:
      return {
        ...state,
        matter: action.payload,
        isLoading: false
      };

    case CREATE_LAW_MATTER:
      return {
        ...state,
        matters: [action.payload, ...state.matters],
        isLoading: false
      };

    case UPDATE_LAW_MATTER:
      return {
        ...state,
        matters: state.matters.map((matter) =>
          matter._id === action.payload._id ? action.payload : matter
        ),
        matter: action.payload,
        isLoading: false
      };

    case DELETE_LAW_MATTER:
      return {
        ...state,
        matters: state.matters.filter((matter) => matter._id !== action.payload),
        isLoading: false
      };

    default:
      return state;
  }
};

export default lawMattersReducer;
